import { signOut } from '@/services/authentication-service/authentication.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ActionCableContext } from '@/providers/action-cable/action-cable.provider';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useJWT } from '../use-jwt/use-jwt';
import { useCompanyStore } from '@/store/app.store';

export function useLogout() {
  const navigate = useNavigate();
  const { removeToken } = useJWT();
  const { removeWSConnection } = useContext(ActionCableContext);
  const queryClient = useQueryClient();
  const { setCompanyName } = useCompanyStore();

  const { mutateAsync: logout } = useMutation({
    mutationFn: signOut,
    onMutate: () => {
      removeToken();
      removeWSConnection();
      setCompanyName(undefined);
      localStorage.removeItem('selectedCompany_initialMessage');
      localStorage.removeItem('selectedCompany_businessHours');
      navigate('/sign-in');

      setTimeout(() => {
        queryClient.clear();
      }, 0);
    },
    onError: () => {},
  });

  return { logout };
}
